import { render } from "./KreyativAbout.vue?vue&type=template&id=675687f8"
const script = {}

import "./KreyativAbout.vue?vue&type=style&index=0&id=675687f8&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_vue@3.2.13_webpack@5.88.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__